import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import KumargraphyDetailsBanner from '../../../assets/casestudy/KumargraphyDetailsBanner.webp';
import KumarPhotography from '../../../assets/casestudy/KumarPhotoGraphy.webp';
import kumarphotography2ndimg from '../../../assets/casestudy/kumarphotography2ndimg.webp';
import kumarphotography3img from '../../../assets/casestudy/kumarphotography3img.webp';
import Mongodbicon from '../../../assets/img/mongodbicon.svg';
import Nodeicon from '../../../assets/img/nodeicon.svg';
import Reacticon from '../../../assets/img/reacticon.svg';
import Expressicon from '../../../assets/img/expressicon.svg';
import ZEEQRCaseStudy from '../../../assets/casestudy/ZEEQRCaseStudy.webp';
import scentabook1stimg from '../../../assets/casestudy/scentabook1stimg.webp';
const KumarsPhotoPage = () => {
  const caseStudiesB = [
 
       {
          image: scentabook1stimg,
          title: 'Scentabook',
          category: 'Website Design',
          pagelink:'/scenta-book',
          link: 'https://scentabook.com'
        },
            {
    image: ZEEQRCaseStudy,
    title: 'Zeeqr',
    category: 'Website Design',
     pagelink:'/zeeqr',
    link: 'https://zeeqr.com/',
  },
  ];
   const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys

      title="Kumar's Photo"
      caseStudies={caseStudiesB}
      subtitle="Crafting a Visual Platform for a Visual Brand"
      header='Crafting a Visual Platform for a Visual Brand'
      // websiteUrl='/projects'
      industry="Photography & Videography"
  services={servicesB}
      description={
        <>
          <span>Kumar's Photography</span> is a creative photography studio with a reputation for capturing the most natural moments — from weddings and brand campaigns to customized shoots. With a strong online and social media presence, the brand felt it was time to take their digital identity to the next level.
        </>
      }
      objective={{
        heading: 'Building a Visual Platform That Showcases Photography and Drives Business Growth',
        content: (
          <>
            <p className={styles.projectText}>
              The main objective was to design and develop a website that truly reflects the visual quality
              and creative essence of Kumar's Photography. The focus was on creating a clean, modern layout
              that puts the photographer at the center of the experience. We wanted every visitor to instantly
              connect with the work — whether they were viewing a wedding shoot, a portrait
              session, or a commercial project. Smooth performance, fast load times, and
              mobile responsiveness were key to keeping the user experience seamless across all devices.
            </p>

            <p className={styles.projectText}>
              Alongside the visual appeal, the website also needed to serve a business purpose. It had to clearly
              present the services offered, allow easy navigation through various photo categories, and guide
              potential clients towards making a booking. The goal was to not only impress visually, but to also
              convert the interest into action by creating a strong, trustworthy, and professional online presence.
            </p>
          </>
        ),
      }}
      process={{
        heading: "Turning Creative Vision Into a Seamless, High-Performance Website",
        content: (
          <>
            <p className={styles.projectText}>
           Our process began with a deep dive into understanding Kumar’s Photography — their style, audience, and goals. We reviewed their portfolio, listened to their story, and studied how they connected with clients through their work. This helped us define a visual direction that felt true to their brand. The focus was on creating a clean, minimal design that let the photographs speak for themselves, while still offering a smooth and intuitive browsing experience. We carefully mapped out the structure, planned the user journey, and designed layouts that worked beautifully across devices
            </p>

         

            <p className={styles.projectText}>
           

Once the design direction was approved, we moved into development with a strong emphasis on performance. Since the website would be image-heavy, we optimized every visual element using formats like WebP, implemented lazy loading, and ensured mobile responsiveness from the start. Each interaction — from gallery filters to the inquiry form — was tested for both functionality and ease of use. We worked closely with the client at every stage, sharing progress, gathering feedback, and making refinements to ensure the final result aligned perfectly with their vision.
            </p>
          </>
        ),
      }}
      impact={{
        heading: 'Repainting the Digital Forefront of Kumar’s Photography',
        content: (
          <>
            <p className={styles.projectText}>
           The newly developed website serves as a centralized hub for Kumar’s Photo, allowing potential clients to browse through the portfolio seamlessly. It provides a structured layout that reflects the brand’s creativity while maintaining a professional and user-friendly interface.
            </p>
           
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
          In conclusion, the Kumar's Photography website effectively fulfills its goal of presenting a visually captivating, user-friendly platform that highlights the photographer’s creative vision and portfolio. The elegant design, smooth performance across devices, and intuitive navigation work together to create an engaging experience for visitors. This website not only showcases the artistry and professionalism behind the brand but also serves as a powerful tool for attracting new clients and expanding Kumar’s digital presence in the competitive photography industry.
            </p>
           
          </>
        ),
      }}
      heroImage={KumargraphyDetailsBanner} // Add the hero image
      projectImage={KumarPhotography}
        projectImage2={kumarphotography2ndimg}
             projectImage3={kumarphotography3img} // Add the project image
      technologies={[
        { name: 'MongoDB', icon: Mongodbicon },
        { name: 'Node.js', icon: Nodeicon },
        { name: 'React', icon: Reacticon },
        { name: 'Express.js', icon: Expressicon },
      ]} // Add the technologies used
      timescale="4 Weeks" // Add the timescale
      launchDate="August 2024" // Add the launch date
    />
  );
};

export default KumarsPhotoPage;